import { createContext } from "react";

// Lets a MenuButton know when one of its items was chosen, so it can close the menu.
// Null when the Menu isn't inside a MenuButton.
export const MenuItemChosenContext = createContext<(() => void) | null>(null);
